/* RESPONSIBLE TEAM: team-ai-agent */
import Service from '@ember/service';
import { tracked } from '@glimmer/tracking';

export type FinAgentType = 'support' | 'sales';

export default class FinAgentTypeService extends Service {
  @tracked currentAgentType: FinAgentType = 'support';
}
